/*
 * @Author: allensunjian Allen_sun_js@hotmail.com
 * @Date: 2024-10-28 11:09:11
 * @LastEditors: allensunjian Allen_sun_js@hotmail.com
 * @LastEditTime: 2026-06-15 13:32:11
 * @FilePath: \xchrmanage_front\src\environments\environment.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
 */
/*
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // 推广测试
  // SERVER_URL: `http://zntg.xcuniv.com/`,
  // 后端测试
  // SERVER_URL: `http://platform.xcuniv.com/`,
  // 前端测试
  SERVER_URL: `https://hrapi.privs.cyqzkj.com/api/`,
  SERVER_URL1: `https://gw.test.center.xcuniv.com/`,
  // SERVER_URL: `https://hradmin.beta.xcuniv.com/api/`,
  // SERVER_URL1: `https://gw.center.xcuniv.com/`,
  production: false,
  useHash: true,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
